/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ShippingOrderCompanyLogDetail {
  logDate?: Date;
  logId?: number;
  newCompanyServiceName?: string;
  newShippingCompanyId?: number;
  newShippingCompanyName?: string;
  newShippingServiceId?: number;
  newShippingServiceName?: string;
  oldCompanyServiceName?: string;
  oldShippingCompanyId?: number;
  oldShippingCompanyName?: string;
  oldShippingServiceId?: number;
  oldShippingServiceName?: string;
  shippingOrderId?: number;
  userEmail?: string;
  userId?: number;
}
